import { render, staticRenderFns } from "./DummyBaseSheetEdit.vue?vue&type=template&id=2d4b5717&scoped=true&"
import script from "./DummyBaseSheetEdit.vue?vue&type=script&lang=ts&"
export * from "./DummyBaseSheetEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DummyBaseSheetEdit.vue?vue&type=style&index=0&id=2d4b5717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b5717",
  null
  
)

export default component.exports